import * as React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import { TableHead, Tooltip } from '@mui/material';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import styled from 'styled-components'
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import ReplyIcon from '@mui/icons-material/Reply';
import DeleteIcon from '@mui/icons-material/Delete';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import { useSelector } from 'react-redux'
import moment from 'moment';
import { useGetAssetsQuery, useUpdateAddAssetStatusMutation, useUpdateflowAddAssetMutation } from '../../../../features/addassets/addassetApiSlice'
import { useAddNewAssetFinalMutation } from "../../../../features/addassets/addassetfinalApiSlice"
import { TableContStyle, TableHeadStyle } from '../../../../Styles/TableStyles'
import useAuth from '../../../../features/hooks/useAuth'
import Popup from 'reactjs-popup';
import { PopupButton } from '../../../../Styles/CommonStyles'
import TextField from '@mui/material/TextField';
import { useGetUsersQuery } from '../../../../features/users/usersApiSlice';
import { useGetconsumablesQuery, useUpdateflowAddConsumableMutation } from '../../../../features/consumable/consumableApiSlice';
import { useGetconsumfinalQuery, useUpdateconsumfinalMutation } from '../../../../features/consumfinal/consumfinalApiSlice';


const StatusButton = styled.button`
width: 80px;
height: 30px;
padding: 5px 7px;
border: none;
border-radius:10px ;
background-color: ${({ type }) => {
    if (type === "approved") {
      return "lightgreen";
    }
    else if (type === "appByLev1") {
      return "#FCCB00";
    }
    else if (type === "draft") {
      return "#D32F2F";
    }
  }};
color: ${({ type }) => {
    if (type === "approved") {
      return "white";
    }
    else if (type === "appByLev1") {
      return "black";
    }
    else if (type === "draft") {
      return "lightgreen";
    }
  }};
`
const StyledIconButton = styled(IconButton)`
margin: 5px;
`
const ActionIconContainer = styled.div`
display: flex;
`
const StyledPreviewIcon = styled(VisibilityIcon)``
const StyledEditIcon = styled(EditIcon)``
const StyledDeleteIcon = styled(DeleteIcon)``
const StyledReturnIcon = styled(ReplyIcon)``
const SignIconContainer = styled.div``
const StyledSignIcon = styled(DesignServicesIcon)``
const SignButtonContainer = styled.div``
const ReturnButtonCont = styled.div`
margin-top: 25px;
padding: 15px;
`
const ReturnButton = styled.button`
display: flex;
align-items: center;
justify-content: center;
/* box-sizing: border-box; */
cursor: pointer;
font-family: "Roboto","Helvetica","Arial",sans-serif;
font-weight: 600;
font-size: 0.75rem;
line-height: 1.75;
letter-spacing: 0.02857em;
text-transform: uppercase;
min-width: 64px;
height: 40px;
padding: 6px 16px;
border-radius: 4px;
border-width: 0;
color: #ebe6e6;
background-color: #008080;
box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12);
margin: 8px;
`
const DetailsCont = styled.div``
const DetailsWrapper = styled.div``
const DetailsItemWrap = styled.div`
display: flex;
flex-direction: column;
padding: 5px;
border: 2px solid black;
border-radius: 10px;
background-color: #97bcd5;
margin-top: 5px;
`
const NameRoleWrap = styled.div`
  display: flex;
justify-content: space-between;
`
const ItemWrapper = styled.div`
display: flex;
`
const KeyWrap = styled.div`
font-weight: bold;
margin-right: 10px;
`
const ValueWrap = styled.div``


const StyledPopup = styled(Popup)``
function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function CustomPaginationActionsTable({ handlePreview }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [remark, setRemark] = useState('')
  const [isPopupOpen, setIsPopupOpen] = useState(false);


  // logged in user info
  const { id, email, designation, designationSuffix, numSuffix, office, roles } = useAuth()
  let user_current_office = (useSelector((state) => state.office.off))
  let user_current_role_array = roles[user_current_office]


  //fetch all addasset documents for appraoval
  const {
    data: assets,
    isLoading,
    isSuccess,
    isError,
    error
  } = useGetAssetsQuery('assets', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });

  const {consumables} =   useGetconsumablesQuery('consumables', {
    selectFromResult: ({ data }) => ({
      consumables: data?.entities
    }),  
  })

  const {consumablefinal} =   useGetconsumfinalQuery('consumablefinal', {
    selectFromResult: ({ data }) => ({
      consumablefinal: data?.entities
    }),  
  })

  //usercall/single user call
  const { getSingleuser } = useGetUsersQuery('userslist', {
    selectFromResult: ({ data }) => ({
      getSingleuser: data?.entities
    }),
  })


  let tempdata = consumables ? Object.values(consumables) : []
  let tabledata = tempdata.filter(elm => elm.addstatus === 'submitted')
  const [addNewAssetFinal, { isLoading: newassetfinalloading }] = useAddNewAssetFinalMutation();
  const [updateAddConsumflow, { isLoading: flowfinalloading }] = useUpdateflowAddConsumableMutation();
  const [updateConsumFinal] = useUpdateconsumfinalMutation();


  const handleReturnClick = async (Id) => {
    try {
      if (user_current_role_array.includes('level1approver')) {
        let flow_details = {
          person_details: { role: 'level1approver', id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
          editstatus: true,
          status: consumables && consumables[Id]?.status,
          remarks: remark,
          time_stamp: new Date()
        }
        let body = { id: Id, flow_details: flow_details }
        await updateAddConsumflow(body)
        setIsPopupOpen(false)

      } else if (user_current_role_array.includes('level2approver')) {
        let flow_details = {
          person_details: { role: 'level2approver', id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
          editstatus: true,
          status: 'draft',
          remarks: remark,
          time_stamp: new Date()
        }
        let body = { id: Id, flow_details: flow_details }
        await updateAddConsumflow(body)
        setIsPopupOpen(false)
      }
    } catch (err) {
      return alert(`Error:${err}`)
    }
  }

  const rows = tabledata
  // handle sign of level-1 approver only status change
  const handleSign_L_1 = async (Id) => {
    try {
      // //update status
      // let body = { status: 'appByLev1', id: Id }
      // await updateAddAssetStatus(body)

      let flow_details = {
        person_details: { role: 'level1approver', id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
        editstatus: false,
        status: 'appByLev1',
        remarks: remark,
        time_stamp: new Date()
      }

      let body = { id: Id, flow_details: flow_details }

      await updateAddConsumflow(body)
      alert('Approved by Level1')
    } catch (err) {
      return alert(`Error:${err}`)
    }
  }

  // handle sign of level-2 approver, the all assets are allocated to store
  const handleSign_L_2 = async (Id) => {
    try {
      let flow_details = {
        person_details: { role: 'level2approver', id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
        editstatus: false,
        status: 'approved',
        remarks: remark,
        time_stamp: new Date()
      }
      let consumFinalBody = {};
      consumFinalBody["consumable"] = consumables[Id].consumable;
      consumFinalBody["partno"] = consumables[Id].partno;
      consumFinalBody["store"] = consumables[Id].cur_store;
      consumFinalBody["oem"] = consumables[Id].cur_store;
      consumFinalBody["order_quantity"] = consumables[Id].order_quantity;
      
      let body = { id: Id, flow_details: flow_details }
      await updateAddConsumflow(body)
      await updateConsumFinal(consumFinalBody);
      alert ('Approved')
    } catch (err) {
      return alert(`Error:${err}`)
    }
  }

  const body = {
    "documentno":1,
    "category":"a",
    "consumable":"b",
    "oem":"",
    "partno":"",
    "store":"",
    "order_details":{},
    "total_order_quantity":0,
    "transactions":{},
  }

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  console.log(rows)

  return (
    <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}>
      <Table sx={{ minWidth: 50 }} aria-label="custom pagination table">
        <TableHead>
          <TableRow sx={{ backgroundColor: TableHeadStyle.backgroundColor }}>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">S.No</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Consum Name</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Order  No.</TableCell>

            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Part No.</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Quantity</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Unit Cost</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">OEM/Vendor</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Date of Purchase</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Status</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Actions</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Details</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Signatories</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : rows
          ).map((row, index) => (
            <TableRow key={index}>
              <TableCell style={{ width: 5 }} component="th" scope="row">
                {index + 1}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {row.consumable}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {row?.orderno? row?.orderno:""}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {row.partno}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {row.order_quantity}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {row.unit_price}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {row.oem}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {moment(row.purchase_date).format('DD/MM/YYYY')}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                <StatusButton type={row.status}>{row.status}</StatusButton>
              </TableCell>
              <TableCell style={{ width: 200 }} align="left">
                <ActionIconContainer>
                  <Tooltip title="Preview">
                    <StyledIconButton onClick={(e) => handlePreview(e, row._id)} color="primary" size='small'>
                      <StyledPreviewIcon />
                    </StyledIconButton>
                  </Tooltip>
                  {row.status === 'approved' || ((user_current_role_array?.includes('level1approver') && row.status !== 'appByLev1') || (user_current_role_array?.includes('level2approver') && row.status !== 'draft')) && row.curr_editstatus !== true && <div className="dropdown-container" style={{ width: '200px' }}>
                    <StyledPopup
                      trigger={
                        <PopupButton style={{ width: 200 }} className="button"> Return to modify </PopupButton>}
                      modal
                      nested
                      open={isPopupOpen}
                      onClose={() => setIsPopupOpen(false)}
                      contentStyle={{ maxHeight: '90%', overflowY: 'auto' }}
                    >
                      <TextField
                        style={{ width: '600px', marginTop: '20px', marginLeft: '20px' }}
                        inputProps={{ style: { height: '38px' } }}
                        value={remark} name='remarks' onChange={(event) => setRemark(event.target.value)} label="Remarks" size="medium" variant="outlined" />
                      <ReturnButtonCont>
                        <ReturnButton onClick={() => handleReturnClick(row._id)}>Confirm Return</ReturnButton>
                      </ReturnButtonCont>
                    </StyledPopup>
                  </div>}
                  {/* <Tooltip title="Delete">
                    <StyledIconButton disabled={["appByLev1", "approved"].includes(row.status)} onClick={() => handleDelete(row._id)} color="primary" size='small'>
                      <StyledDeleteIcon />
                    </StyledIconButton>
                  </Tooltip> */}
                </ActionIconContainer>
              </TableCell>
              <TableCell style={{ width: 100 }} align="right">
                <div className="dropdown-container" style={{ width: '100px' }}>
                  <StyledPopup
                    trigger={
                      <PopupButton style={{ width: 100 }} className="button"> Details </PopupButton>}
                    modal
                    nested
                    open={isPopupOpen}
                    onClose={() => setIsPopupOpen(false)}
                    contentStyle={{ width: '600px',maxHeight: 'auto', overflowY: 'auto' }}
                  >
                    < DetailsCont>
                      <DetailsWrapper>
                        {row.flow_data?.map((elm, ind) => <DetailsItemWrap key={ind}>
                          <NameRoleWrap>
                            <ItemWrapper>
                              <KeyWrap>Role:</KeyWrap>
                              <ValueWrap>{elm.person_details.role}</ValueWrap>
                            </ItemWrapper>
                            <ItemWrapper>
                              <KeyWrap>User Details:</KeyWrap>
                              <ValueWrap>{`${elm.person_details.name.firstName} ${elm.person_details.name.middleName} ${elm.person_details.name.lastName}- ${elm.person_details.designation}`}</ValueWrap>
                            </ItemWrapper>
                          </NameRoleWrap>
                          <ItemWrapper>
                            <KeyWrap>Status:</KeyWrap>
                            <ValueWrap>{elm.status}</ValueWrap>
                          </ItemWrapper>
                          {elm.remarks.length > 0 && <ItemWrapper>
                            <KeyWrap>Remark:</KeyWrap>
                            <ValueWrap>{elm.remarks}</ValueWrap>
                          </ItemWrapper>}
                          {elm.editstatus && <ItemWrapper>
                            <KeyWrap>Returned to modify:</KeyWrap>
                            <ValueWrap>{elm.editstatus && 'YES'}</ValueWrap>
                          </ItemWrapper>}
                        </DetailsItemWrap>)}
                      </DetailsWrapper>
                    </DetailsCont>
                  </StyledPopup>
                </div>
              </TableCell>
              <TableCell style={{ width: 300 }} align="right">
                <SignIconContainer>
                  {user_current_role_array?.includes('L1Approver_C') && <SignButtonContainer>
                    <StyledIconButton disabled={(row.status === "approved") || (row.status === "appByLev1") || (row.curr_editstatus === true)} onClick={() => handleSign_L_1(row._id)} color="secondary" size='small'><StyledSignIcon />
                      Level-I
                    </StyledIconButton>
                  </SignButtonContainer>}
                  {user_current_role_array?.includes('L2Approver_C') && <SignButtonContainer>
                    <StyledIconButton disabled={(row.status === "approved") || (row.status === "draft") || (row.curr_editstatus === true)} onClick={() => handleSign_L_2(row._id)} color="secondary" size='small'><StyledSignIcon />
                      Level-II
                    </StyledIconButton>
                  </SignButtonContainer>}
                </SignIconContainer>
              </TableCell>
            </TableRow>
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={9}
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}
